import httpClient from "../httpClient";

const END_POINT = '/user'

const getUsers = () => httpClient.get(END_POINT)
const getUserById = (userId) => httpClient.get(`${END_POINT}/${userId}`)
const createUser = (user) => httpClient.post(END_POINT, user)
const updateUser = (id, user) => httpClient.put(`${END_POINT}/${id}`, user)
const toggleIsAvailable = (id) => httpClient.put(`${END_POINT}/available/${id}`)

export {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  toggleIsAvailable
}